import base from './base2.repository';
export default {
    get: params => base.get('service-spots', params),
    getTypes: () => base.get('service-spots/types'),
    save: payload => base.post('service-spots', payload),
    update: (payload, id) => base.put(`service-spots/${id}`, payload),
    delete: id => base.delete(`service-spots/${id}`)
}